import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BreakdownBarList } from './BreakdownBarList';
import type { DomainBreakdownRow } from '../../types/activity-overview';

interface DomainBreakdownProps {
  rows: DomainBreakdownRow[];
}

/**
 * By Domain — one row per domain in canonical level order. The neutral pine
 * dot is deliberate: the domain palette is not used in this feature.
 */
export function DomainBreakdown({ rows }: DomainBreakdownProps) {
  return (
    <Card className="bg-pine-card border-pine-line shadow-pine-card rounded-pine-card">
      <CardHeader>
        <CardTitle className="text-heading-4 text-pine-ink">By Domain</CardTitle>
      </CardHeader>
      <CardContent>
        <BreakdownBarList
          rows={rows.map((row) => ({
            key: String(row.id),
            label: (
              <span className="flex items-center gap-2">
                <span className="inline-block h-2.5 w-2.5 shrink-0 rounded-full bg-pine-pine" />
                <span className="truncate">{row.title}</span>
              </span>
            ),
            primary: row.activityCount,
            secondary: row.stageAssignmentCount,
            secondaryLabel: 'active stages',
          }))}
        />
      </CardContent>
    </Card>
  );
}
